import { Injectable, inject } from '@angular/core';
import { map, ReplaySubject } from 'rxjs';
import { BildungsangebotTerminDetail } from '../../model';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class CommonStateService {
  private readonly urlService = inject(UrlService);

  private readonly _selectedTermin$ = new ReplaySubject<BildungsangebotTerminDetail | null>();

  public selectedTermin$ = this._selectedTermin$.asObservable();

  public selectedAngebotId$ = this.urlService
    .getQueryParameterValue(UrlService.SELECTED_ANGEBOT)
    .pipe(map(Number));

  public setSelectedTermin(termindId: BildungsangebotTerminDetail | null): void {
    this._selectedTermin$.next(termindId);
  }

  public setSelectedAngebotId(angebotId: number | null): void {
    this.urlService.updateUrlQueryParams({
      [UrlService.SELECTED_ANGEBOT]: angebotId
    });
  }
}
